module.exports = __webpack_public_path__ + "static/media/logo-en.0602459d.png";